require('./fund-view');
import { FundSearchView } from './fund-search';

$(() => {
  new FundSearchView();
});
